<template>    
  <div>
    <b-input-group size="sm" :prepend="getCurrencySymbol">
      <b-form-input :value="totalFormat"
                    type="text"
                    :readonly="true"
                    class="input-cash-total"
                    @change="openCrud()">
      </b-form-input>

      <b-input-group-append>
        <b-button variant="outline-info"
                  @click="openCrud()"
                  title="Cargar el detalle del importe recibido por cada medios de pago"
                  class="button-cash-open">
          Importes
          <AppIcon name="chevron-double-right" />
        </b-button>
      </b-input-group-append>
    </b-input-group>

    <!-- ########################### -->
    <!-- #####     MODALES     ##### -->
    <!-- ########################### -->

    <!-- CRUD MAIN -->
    <b-modal v-model="modal.form.active">
      <div slot="modal-header" class="app-modal-header">
        <span class="app-modal-header__icon"><AppIcon name="money" /></span>
        <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
      </div>

      <b-row :key="keyForceUpdate">
        <b-col md="10">
          <b-row>
            <b-col md="7" class="pr-md-0">
              <FindObject type="cash"
                          tag="Caja/Cuenta"
                          @select-object="loadCash($event)"
                          :valueID="crud.formTMP.cash_id"
                          :where="conditionCash"
                          :orWhere="conditionCashOr"
                          render="search"
                          :showAllRegister="true"/>
            </b-col>
            <b-col md="5" class="pl-md-1 pr-md-1">
              <b-form-group label="Importe">
                <b-input-group size="sm" prepend="$">
                  <app-number-input size="sm"
                                v-model="crud.formTMP.total"
                                placeholder="Ingrese un importe" />
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-col>

        <b-col md="2">
          <!-- Desktop: cuadrado ícono-only, cabe en la columna angosta.
               Mobile: la columna pasa a 100% de ancho (sin breakpoint) —
               ícono solo quedaba perdido con un hueco enorme arriba. -->
          <b-button variant="success" @click="add()" size="sm" title="Agregar" class="app-form-row-add-btn d-none d-md-inline-flex">
            <AppIcon name="add" />
          </b-button>
          <b-button variant="success" @click="add()" size="sm" class="app-form-row-add-btn d-md-none">
            <AppIcon name="add" class="mr-1" />Agregar
          </b-button>
        </b-col>

        <b-col md="12" v-if="crud.formTMP.cash && type=='SUB'">
          <b-alert variant="success" v-if="crud.formTMP.cash.total_available_ars>0" show>
            <AppIcon name="check_circle" class="mr-1" /><b>DISPONIBLE EN: {{this.crud.formTMP.cash.name}}":</b> {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyCode}).format(this.crud.formTMP.cash.total_available_ars)}}
          </b-alert>
          <b-alert variant="danger" v-if="crud.formTMP.cash.total_available_ars<0 && crud.formTMP.cash.uncovered" show>
            <AppIcon name="exclamation-triangle" class="mr-1" /><b>EN DESCUBIERTO: {{this.crud.formTMP.cash.name}}":</b> {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyCode}).format(this.crud.formTMP.cash.total_available_ars)}}
          </b-alert>
          <b-alert variant="danger" v-if="crud.formTMP.cash.total_available_ars<0 && !crud.formTMP.cash.uncovered" show>
            <AppIcon name="exclamation-triangle" class="mr-1" /><b>SIN SALDO</b>
          </b-alert>
        </b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col>
          <b-row>
            <b-col md="12">
              <b-table  class="mb-0 app-table app-table--compact table-cash-sub"
                        responsive
                        :hover="true"
                        :small="true"
                        :fixed="true"
                        :items="table.items"
                        :fields="table.fields"
                        v-if="table.items.length">

                <template v-slot:table-colgroup="scope">
                  <col
                    v-for="field in scope.fields"
                    :key="field.key"
                    :style="{ width: field.width }"
                  >
                </template>

                <template v-slot:cell(cash)="data">
                  {{data.item.cash.name}}
                </template>

                <template v-slot:cell(importe)="data">
                  {{Intl.NumberFormat('es-AR',{style:'currency',currency: getCurrencyCode}).format(data.item.total)}}
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right
                              no-caret
                              size="sm"
                              variant="link"
                              boundary="window"
                              toggle-class="app-table-action-toggle"
                              class="pull-right">
                    <template #button-content>
                      <AppIcon name="more_vert" label="Acciones" />
                    </template>
                    <b-dropdown-item @click="edit(data.item, data.index)">
                      <AppIcon name="edit" /> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="remove(data.index)">
                      <AppIcon name="delete" class="text-danger" /> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
              <EmptyState v-else icon="money" title="No se encontraron registros" />
            </b-col>
          </b-row>
        </b-col>
      </b-row>

      <div slot="modal-footer">
        <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
        <b-button variant="dark" @click="save()"><AppIcon name="check_circle" class="mr-1" />Guardar</b-button>
      </div>

    </b-modal>
  </div>
</template>
<script>  
  import serviceAPI from './../services'
  import ErrorToken from '@/handler/errorToken'
  import Helper from '@/handler/helper'
  import FindObject from '@/components/inc/find/findObject'  
  import Param from '@/config/parameters'

  export default {
    props: {
      reset: {
        type: Boolean,
        default: false
      },
      points_sales: {
        type: Object,
        default: null,
      },       
      type: {
        type: String,
        default: 'ADD',
      },   
      amount_pending: {
        type: Number,
        default: 0,
      }
    },
    components: {
      FindObject,      
    },    
    data: () => {
      return { 
        crud: {
          form: {
            total: 0,          
            detail: [],
          },
          formTMP: {
            cash_id: 0,
            cash: null,
            total: 0,
          },
        },     
        table : {
          items: [],
          fields: [
            {key: 'cash', label: 'Caja/Cuenta', class:"align-middle text-left", width:"40%"},
            {key: 'importe', label: 'Importe', class:"align-middle text-right", width:"40%"},       
            {key: 'f_action', label: '', class:"align-middle text-center", width:"20%"}        
          ]
        },             
        modal: {
          form: {
            active: false,
            title: ''
          },          
        },   
        object: {
          staff: null
        },
        keyForceUpdate: 0, 
        parameters: {
          freeAddTypeOperation: false
        }       
      }
    }, 
    computed: {
      // CONDITIONS SELECT
      conditionCash(){        
        var arrWhere = []
        if(!this.parameters.freeAddTypeOperation) {
          arrWhere.push({field: 'nd', condition: this.points_sales.nd})
        }         
        arrWhere.push({field: 'active', condition: true})
        return arrWhere;
      },   
      conditionCashOr() {
        var arrWhere = []  
        if(this.object.staff && this.object.staff.cash_id) {
          arrWhere.push({field: 'id', condition: this.object.staff.cash_id})
          arrWhere.push({field: 'shared', condition: true})     
        } else {
          if(this.points_sales.cash_id) {
            arrWhere.push({field: 'id', condition: this.points_sales.cash_id})
            arrWhere.push({field: 'shared', condition: true})     
          }
        }
        return arrWhere;
      },        
      // CURRENCY
      getCurrencySymbol() {
        return '$'
      },
      getCurrencyCode() {
        return 'ARS'
      },
      // El total de arriba es de solo lectura — sin esto se veía crudo
      // (ej. "12345.6" en vez de "$ 12.345,60").
      totalFormat() {
        return Intl.NumberFormat('es-AR',{style:'currency',currency: this.getCurrencyCode}).format(this.crud.form.total || 0)
      }
    },
    watch: {
      'reset': function (newQuestion, oldQuestion) {    
        if(newQuestion == true) {          
          this.crud.form = {
            total: 0,          
            detail: [],       
          },

          this.table.items = []
          
          this.$emit('getFinancesCash', this.crud.form)     
        }
      },
      'amount_pending': function (newQuestion, oldQuestion) {         
        if(newQuestion) {  
          this.crud.formTMP.total = Math.abs(this.amount_pending)        
        }   
      }
    },        
    mounted() {
      this.parameters.freeAddTypeOperation = Helper.hasParametersAccess(Param.P61)

      this.showStaff()      
      this.searchCash()
    },
    methods: {        
      // CRUD   
      searchCash() {        
        var result = serviceAPI.obtenerCajas()

        result.then((response) => {
          var data = response.data
          
          if(data.length) {              
            this.crud.formTMP.cash = data[0]
            this.crud.formTMP.cash_id = data[0].id
            this.forceUpdate()
          }      
          

          if(this.object.staff && this.object.staff.cash_id) {
            this.crud.formTMP.cash_id = this.object.staff.cash_id
            this.forceUpdate()
          } else {
            if(this.points_sales.cash_id) {
              this.crud.formTMP.cash_id = this.points_sales.cash_id
              this.forceUpdate()
            }
          }
        })                  
      },
      openCrud() {      
        this.modal.form.title = "Detalle de importe por medios de pago"
        this.modal.form.active = true        
      },
      edit(item, index) {
        this.crud.formTMP.cash_id = item.cash_id
        this.crud.formTMP.cash = item.cash  
        this.crud.formTMP.total = item.total
                             
        this.crud.form.detail.splice(index, 1)       
        this.forceUpdate()
      },      
      add() {
        // CAJA/CUENTA SIN CARGAR
        if(!parseFloat(this.crud.formTMP.cash_id)) {
          this.$awn.alert("No puede cargar un item sin caja/cuenta");
          return false          
        }       

        // NO SE PUEDE GUARDAR MAS DE UNA VEZ LA MISMA CAJA/CUENTA
        var existe = false
        if(this.crud.form.detail.length) {
          this.crud.form.detail.forEach(element => {
            if(element.cash_id == this.crud.formTMP.cash_id) {              
              existe = true
            }
          });
        }
        if(existe) {
          this.$awn.alert("Ya existe un item con la misma caja/cuenta");
          return false
        }        

        // TOTAL MAYOR A CERO
        if(parseFloat(this.crud.formTMP.total) <= 0) {
          this.$awn.alert("No puede agregar el total en cero o menor a cero");
          return false          
        }       

        // SI ES UN PAGO
        if(this.type == 'SUB') {
          if(!this.crud.formTMP.cash.uncovered) {          
            if(parseFloat(this.crud.formTMP.cash.total_available_ars) < parseFloat(this.crud.formTMP.total)) {
              this.$awn.alert("No puede emitir un pago por un total mayor al disponible en caja/cuenta");
              return false                      
            }
          }
        }

        this.crud.form.detail.push({
          cash: this.crud.formTMP.cash,
          cash_id: this.crud.formTMP.cash_id,
          total: this.crud.formTMP.total,            
        })

        this.table.items = this.crud.form.detail 
        this.clear()
      },  
      save() {
        var sum = 0
        if(this.crud.form.detail) {                    
          this.crud.form.detail.forEach(element => {            
            sum = sum + parseFloat(element.total)
          });
        }
        this.crud.form.total = parseFloat(sum.toFixed(2))          
        this.$emit('getFinancesCash', this.crud.form)      
        this.modal.form.active = false   
      },    
      remove(index) {
        this.crud.form.detail.splice(index, 1)
      },      
      clear() {      
        this.crud.formTMP.cash_id = 0
        this.crud.formTMP.cash = null
        this.crud.formTMP.total = 0         
        this.forceUpdate()         
      },
      forceUpdate() {
        this.keyForceUpdate = this.keyForceUpdate + 1
      },     
      loadCash(object){
        if(object){
          this.crud.formTMP.cash = object
          this.crud.formTMP.cash_id = object.id
        } else {
          this.crud.formTMP.cash = null
          this.crud.formTMP.cash_id = 0
        }
      },       
      showStaff()  {
        let staffID = Helper.getStaffId()
        var result = serviceAPI.mostrarStaff(staffID)

        result.then((response) => {
          var data = response.data
          if(data) {
            this.object.staff = data
          } else {
            this.object.staff = null
          }                     
        })          
      }
    }
  }
</script>
<style>
  .table-cash-sub {
    min-height: 100px;
  }
  .button-cash-open {
    min-width: 135px;
    font-weight: 800;
    text-align: right;
  }     
  .input-cash-total {
    font-weight: 800;
  } 
</style>